/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { api } from './api';
import { T } from './tema';
import { Glas, Label, Input, Knap } from './components/Ui';
import PasskeyIndstillinger from './components/PasskeyIndstillinger';
export default function BrugerProfil({ bruger = { navn:"René Sørensen", email:"direktoer@skilsmissevej.dk", rolle:"direktoer", initialer:"RS" }, onTilbage }) {
 const [aktiv_tab, setAktivTab] = useState("profil");
 const [gem_besked, setGemBesked] = useState("");
 const [profil, setProfil] = useState({ navn: bruger.navn || "", email: bruger.email || "", telefon: "", profilbillede: "" });
 const [pw, setPw] = useState({ nuværende:"", ny:"", bekræft:"" });
 const [vis_pw, setVisPw] = useState(false);
 const [notif_pref, setNotifPref] = useState({ email_deadlines:true, email_kritiske:true, browser_push:false, daglig_opsummering:true });
 useEffect(() => {
 let afbrudt = false;
 (async () => {
 try {
 const res = await api("brugere/profil", "GET");
 if (afbrudt || !res || res.fejl) return;
 const b = res.bruger || {};
 setProfil({
 navn: b.navn || bruger.navn || "",
 email: b.email || bruger.email || "",
 telefon: b.telefon || "",
 profilbillede: b.profilbillede || "",
 });
 if (b.indstillinger && typeof b.indstillinger === "object" && b.indstillinger.notifikationer) {
 setNotifPref(p => ({ ...p, ...b.indstillinger.notifikationer }));
 }
 } catch(e) { /* fallback til bruger-props */ }
 })();
 return () => { afbrudt = true; };
 }, []);
 const gem = async () => {
 if (aktiv_tab === "sikkerhed") {
 if (!pw.nuværende) { setGemBesked(" Indtast nuværende adgangskode"); return; }
 if (pw.ny.length < 8) { setGemBesked(" Mindst 8 tegn"); return; }
 if (pw.ny !== pw.bekræft) { setGemBesked(" Koderne matcher ikke"); return; }
 try {
 const res = await api("auth/skift-adgangskode", "POST", {
 nuværende: pw.nuværende,
 ny: pw.ny
 });
 if (res && res.fejl) { setGemBesked(" " + res.fejl); return; }
 setGemBesked(" Adgangskode ændret — log ind igen med den nye kode");
 setPw({ nuværende:"", ny:"", bekræft:"" });
 } catch(err) {
 setGemBesked(" Fejl ved skift af adgangskode");
 }
 } else if (aktiv_tab === "notif") {
 try {
 const res = await api("brugere/profil", "PATCH", {
 indstillinger: { notifikationer: notif_pref },
 });
 if (res && res.fejl) setGemBesked(" " + res.fejl);
 else setGemBesked(" Notifikationer gemt");
 } catch(err) {
 setGemBesked(" Fejl ved gemning");
 }
 setTimeout(() => setGemBesked(""), 2500);
 } else {
 try {
 const gemt_bruger = JSON.parse(sessionStorage.getItem("sv_bruger") || "{}");
 const res = await api("brugere/profil", "PATCH", {
 navn: profil.navn,
 email: profil.email,
 telefon: profil.telefon,
 profilbillede: profil.profilbillede,
 });
 if (res && res.fejl) {
 setGemBesked(" " + res.fejl);
 } else {
 const opdateret = { ...gemt_bruger, navn: profil.navn, email: profil.email,
 telefon: profil.telefon, profilbillede: profil.profilbillede };
 sessionStorage.setItem("sv_bruger", JSON.stringify(opdateret));
 setGemBesked(" Profil gemt");
 }
 } catch(err) {
 setGemBesked(" Kunne ikke gemme profil");
 }
 setTimeout(() => setGemBesked(""), 2500);
 }
 };
 const ROLLE_LABEL = { direktoer:"Direktør", sagsbehandler:"Sagsbehandler", specialist:"Specialist", systemadmin:"Systemadministrator", ai_governance:"AI Governance", "infoskærm":"Infoskærm" };
 const ROLLE_FARVE = { direktoer:T.turkis, sagsbehandler:"#60a5fa", specialist:"#c084fc", systemadmin:"#ffd166", ai_governance:T.groen, "infoskærm":"#fb923c" };
 const rf = ROLLE_FARVE[bruger.rolle] || T.dæmpet;
 const pw_styrke = (pw) => {
 let s = 0;
 if (pw.length >= 8) s++;
 if (pw.length >= 12) s++;
 if (/[A-Z]/.test(pw)) s++;
 if (/[0-9]/.test(pw)) s++;
 if (/[^A-Za-z0-9]/.test(pw)) s++;
 return s;
 };
 const styrke = pw_styrke(pw.ny);
 const styrke_farve = styrke <= 1 ? T.roed : styrke <= 3 ? T.gul : T.groen;
 const styrke_label = ["","Meget svag","Svag","Middel","God","Meget stærk"][styrke] || "";
 const TABS = [
 { id:"profil", label:"Min profil", ikon:"" },
 { id:"sikkerhed", label:"Adgangskode", ikon:"" },
 { id:"notif", label:"Notifikationer",ikon:"" },
 ];
 return (
 <div style={{ display:"flex", flexDirection:"column" }}>
 {gem_besked && <div style={{ padding:"10px 20px", background:"rgba(39,174,96,0.1)", borderBottom:"1px solid rgba(39,174,96,0.2)", textAlign:"center", color:"#27ae60", fontSize:13 }}>{gem_besked}</div>}
 <div style={{ flex:1, padding:"clamp(16px, 3vw, 28px) clamp(16px, 4vw, 40px)", maxWidth:1200, margin:"0 auto", width:"100%" }}>
 {/* Profilkort øverst */}
 <Glas style={{ padding:"24px", marginBottom:20, display:"flex", alignItems:"center", gap:20, position:"relative", overflow:"hidden" }}>
 {/* Accent strip */}
 <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:`linear-gradient(90deg, ${rf}, ${rf}44, transparent)`, borderRadius:"16px 16px 0 0", pointerEvents:"none" }} />
 {/* Glow orb */}
 <div style={{ position:"absolute", top:-20, right:-20, width:120, height:120, borderRadius:"50%", background:`${rf}08`, filter:"blur(25px)", pointerEvents:"none" }} /> <div style={{ position:"relative", flexShrink:0 }}> <div style={{ width:72, height:72, borderRadius:"50%", background: profil.profilbillede ? `url(${profil.profilbillede}) center/cover` : `${rf}22`, border:`2px solid ${rf}`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:24, fontWeight:500, color:rf, overflow:"hidden" }}>
 {!profil.profilbillede && (bruger.initialer || (bruger.navn||"RS").split(" ").map(n=>n[0]).join("").slice(0,2))}
 </div> </div> <div> <div style={{ fontSize:18, fontWeight:500, color:T.creme, marginBottom:4 }}>{profil.navn}</div> <div style={{ fontSize:12, color:T.dæmpet, marginBottom:8 }}>{profil.email}</div> <span style={{ fontSize:12, letterSpacing:"0.1em", textTransform:"uppercase", padding:"3px 10px", borderRadius:4, color:rf, background:`${rf}18`, border:`1px solid ${rf}30` }}>
 {ROLLE_LABEL[bruger.rolle] || bruger.rolle}
 </span> </div> </Glas>
 {/* Tabs */}
 <div style={{ display:"flex", borderBottom:T.skillelinje, marginBottom:20 }}>
 {TABS.map(t => (
 <button key={t.id} onClick={()=>setAktivTab(t.id)} style={{ background:"none", border:"none", padding:"10px 16px", color: aktiv_tab===t.id ? T.turkis : T.dæmpet, borderBottom: aktiv_tab===t.id ? `2px solid ${T.turkis}` : "2px solid transparent", fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif", display:"flex", alignItems:"center", gap:6 }}> <span style={{ fontSize:14 }}>{t.ikon}</span> {t.label}
 </button>
 ))}
 </div>
 {/* ── TAB: PROFIL ── */}
 {aktiv_tab==="profil" && (
 <Glas style={{ padding:24, animation:"sv-panel-enter 0.4s cubic-bezier(0.34,1.56,0.64,1) both" }}> <Label>Fulde navn</Label> <Input value={profil.navn} onChange={e=>setProfil(p=>({...p,navn:e.target.value}))} placeholder="Dit fulde navn" /> <Label>Email</Label> <Input value={profil.email} onChange={e=>setProfil(p=>({...p,email:e.target.value}))} placeholder="din@email.dk" type="email" /> <Label>Mobilnummer</Label> <Input value={profil.telefon} onChange={e=>setProfil(p=>({...p,telefon:e.target.value}))} placeholder="+45 XX XX XX XX" type="tel" /> <div style={{ marginTop:4 }}> <Label>Profilbillede</Label> <div style={{ display:"flex", gap:12, alignItems:"center" }}> <div style={{ width:56, height:56, borderRadius:"50%", background: profil.profilbillede ? `url(${profil.profilbillede}) center/cover` : `${rf}22`, border:`1px solid ${rf}44`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:20, color:rf, overflow:"hidden" }}>
 {!profil.profilbillede && (bruger.initialer || "RS")}
 </div> <div> <label style={{ cursor:"pointer" }}> <input type="file" accept="image/jpeg,image/png" style={{ display:"none" }} onChange={e=>{
 const fil = e.target.files[0];
 if (!fil) return;
 if (fil.size > 2*1024*1024) { setGemBesked(" Billedet er for stort (max 2MB)"); return; }
 const reader = new FileReader();
 reader.onload = evt => {
 setProfil(p => ({ ...p, profilbillede: evt.target.result }));
 setGemBesked(" Billede valgt — klik 'Gem ændringer'");
 setTimeout(()=>setGemBesked(""), 2500);
 };
 reader.readAsDataURL(fil);
 }} /> <span style={{ display:"inline-block", padding:"8px 16px", background:`${T.turkis}22`, border:`1px solid ${T.turkis}55`, borderRadius:8, color:T.turkis, fontSize:12, fontFamily:"'Inter',system-ui,sans-serif", cursor:"pointer" }}>
 Upload billede
 </span> </label>
 {profil.profilbillede && (
 <button onClick={()=>setProfil(p=>({...p, profilbillede:""}))} style={{ marginLeft:8, padding:"8px 12px", background:"transparent", border:`1px solid ${T.dæmpet}44`, borderRadius:8, color:T.dæmpet, fontSize:12, cursor:"pointer" }}>Fjern</button>
 )}
 <div style={{ fontSize:12, color:T.dæmpet, marginTop:6 }}>JPG eller PNG · Max 2MB</div> </div> </div> </div> <div style={{ marginTop:20 }}> <Knap onClick={gem} style={{ width:"100%" }}>Gem ændringer</Knap> </div> </Glas>
 )}
 {/* ── TAB: ADGANGSKODE ── */}
 {aktiv_tab==="sikkerhed" && (
 <Glas style={{ padding:24, animation:"sv-panel-enter 0.4s cubic-bezier(0.34,1.56,0.64,1) both" }}> <Label>Nuværende adgangskode</Label> <div style={{ position:"relative", marginBottom:16 }}> <input type={vis_pw?"text":"password"} value={pw.nuværende} onChange={e=>setPw(p=>({...p,nuværende:e.target.value}))} placeholder="Din nuværende adgangskode"
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:9, padding:"12px 44px 12px 15px", color:T.creme, fontSize:14 }} /> <button onClick={()=>setVisPw(p=>!p)} style={{ position:"absolute", right:12, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", color:T.dæmpet, fontSize:14, cursor:"pointer" }}>
 {vis_pw?"":""}
 </button> </div> <div style={{ height:2, background:"rgba(13,148,136,0.38)", margin:"4px 0 16px" }} /> <Label>Ny adgangskode</Label> <div style={{ position:"relative", marginBottom:0 }}> <input type={vis_pw?"text":"password"} value={pw.ny} onChange={e=>setPw(p=>({...p,ny:e.target.value}))} placeholder="Min. 8 tegn"
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:`1px solid ${pw.ny ? styrke_farve+"66" : "rgba(255,255,255,0.06)"}`, borderRadius:9, padding:"12px 44px 12px 15px", color:T.creme, fontSize:14 }} /> </div>
 {pw.ny && (
 <div style={{ marginTop:8, marginBottom:14 }}> <div style={{ display:"flex", gap:4, marginBottom:4 }}>
 {[1,2,3,4,5].map(i=>(
 <div key={i} style={{ flex:1, height:3, borderRadius:2, background: i<=styrke ? styrke_farve : "rgba(255,255,255,0.08)", transition:"all 0.3s" }} />
 ))}
 </div> <div style={{ fontSize:12, color:styrke_farve }}>{styrke_label}</div> </div>
 )}
 <Label>Bekræft ny adgangskode</Label> <div style={{ position:"relative", marginBottom:16 }}> <input type={vis_pw?"text":"password"} value={pw.bekræft} onChange={e=>setPw(p=>({...p,bekræft:e.target.value}))} placeholder="Gentag ny adgangskode"
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:`1px solid ${pw.bekræft&&pw.bekræft===pw.ny ? T.turkis+"66" : pw.bekræft ? T.roed+"66" : "rgba(255,255,255,0.06)"}`, borderRadius:9, padding:"12px 15px", color:T.creme, fontSize:14 }} />
 {pw.bekræft && pw.bekræft===pw.ny && <div style={{ fontSize:12, color:T.turkis, marginTop:4 }}> Adgangskoder matcher</div>}
 {pw.bekræft && pw.bekræft!==pw.ny && <div style={{ fontSize:12, color:T.roed, marginTop:4 }}>Matcher ikke</div>}
 </div> <div style={{ background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:9, padding:"12px 14px", marginBottom:20 }}> <div style={{ fontSize:12, color:T.dæmpet, lineHeight:1.7 }}>
 Adgangskode krypteres med bcrypt · Sessioner nulstilles ved skift · Alle enheder logges ud
 </div> </div> <Knap onClick={gem} style={{ width:"100%" }}
 disabled={!pw.nuværende || !pw.ny || pw.ny!==pw.bekræft || styrke<2}>
 Skift adgangskode
 </Knap>
 <PasskeyIndstillinger />
 </Glas>
 )}
 {/* ── TAB: NOTIFIKATIONER ── */}
 {aktiv_tab==="notif" && (
 <Glas style={{ padding:24, animation:"sv-panel-enter 0.4s cubic-bezier(0.34,1.56,0.64,1) both" }}> <div style={{ fontSize:13, color:T.dæmpet, marginBottom:18, lineHeight:1.7 }}>
 Tilpas hvordan du modtager beskeder. Kritiske deadlines kan ikke slås fra.
 </div>
 {[
 { id:"email_kritiske", label:"Email ved kritiske deadlines", sub:"Deadline overskredet eller i dag", låst:true },
 { id:"email_deadlines", label:"Email-påmindelser om deadlines", sub:"3 dage og 1 dag før frist", låst:false },
 { id:"daglig_opsummering",label:"Daglig opsummering", sub:"Sendes kl. 07:00 hver hverdag", låst:false },
 { id:"browser_push", label:"Browser push-notifikationer", sub:"Direkte i browseren på din PC", låst:false },
 ].map(item => (
 <div key={item.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"12px 0", borderBottom:T.skillelinje }}> <div> <div style={{ fontSize:13, color: item.låst ? T.dæmpet : T.lys, marginBottom:2 }}>{item.label}</div> <div style={{ fontSize:12, color:T.subtil }}>{item.sub}</div>
 {item.låst && <div style={{ fontSize:12, color:T.roed, marginTop:3, letterSpacing:"0.05em" }}> Kan ikke slås fra</div>}
 </div> <button onClick={()=>!item.låst && setNotifPref(p=>({...p,[item.id]:!p[item.id]}))}
 style={{ width:44, height:24, borderRadius:16, border:"none", cursor: item.låst ? "default" : "pointer", position:"relative", background: (notif_pref[item.id]||item.låst) ? T.turkis : "rgba(255,255,255,0.06)", opacity: item.låst ? 0.6 : 1, transition:"background 0.2s", flexShrink:0 }}> <div style={{ width:18, height:18, borderRadius:"50%", background:"white", position:"absolute", top:3, left:(notif_pref[item.id]||item.låst)?23:3, transition:"left 0.2s", boxShadow:"0 1px 4px rgba(0,0,0,0.3)" }} /> </button> </div>
 ))}
 <div style={{ marginTop:20 }}> <Knap onClick={gem} style={{ width:"100%" }}>Gem notifikationsindstillinger</Knap> </div> </Glas>
 )}
 </div> </div>
 );
}
